<template>
    <g>
        <path d="M1 3.77778V1H3.77778" stroke="white" stroke-width="2"/>
        <path d="M11 8.22222L11 11L8.22222 11" stroke="white" stroke-width="2"/>
        <path d="M8.22222 1L11 1L11 3.77778" stroke="white" stroke-width="2"/>
        <path d="M3.77778 11L1 11L1 8.22222" stroke="white" stroke-width="2"/>
    </g>

</template>